import type { Format } from './format'

/** A deck keeps authored content in slide rows; its identity body stays empty. */
export const slides = {
  bodyStorage: 'rows',
  validate: (body: string) => body === '',
  outline: () => [],
  searchText: () => '',
  tools: [],
} as const satisfies Format
